import axiosInstance from "./global";
import CONFIG from "../../config";

const baseURL = `${CONFIG.BASE_URL}/fraud-service/api/v1/rules`;

export const createFraudRule = async (payload) =>
  await axiosInstance
    .post(`${baseURL}`, payload)
    .then((res) => res.data)
    .catch((err) => {
      throw new Error(err?.response?.data?.message || "Failed to create rule");
    });